import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `@shn/phg-client-web` — application entry point for the PHG web
 * client (SHT's first-party patient-facing application; "Smart
 * Health account" in user-facing copy).
 *
 * Architectural commitments per the DEV5 onboarding handoff:
 *   - PHG composes substrate primitives at the patient-facing
 *     surface (ADR-026; not itself a primitive)
 *   - Active-session-only crypto with zeroize-on-end (Tech Spec
 *     §6.2.3 + scope memo §5.1)
 *   - SHT-mediated consent flows for third-party app access
 *     (ADR-027); external apps never render PHG consent UI in
 *     their own surface
 *   - Recovery UX honesty about failure consequences is doctrinal
 *     (PFO §4 + Patient-Facing Terms v1.3 once landed)
 *
 * SCAFFOLD: minimal entry. Only mounts the app shell when running
 * in a browser context (`window` defined). Importing this module
 * from Node-targeted tests does not trigger DOM mounting; tests
 * exercise the `App` component directly via `@testing-library/react`.
 */
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
// Lightning Strike v0.4 Path A canonical preservation forward (CPL deposit
// 2026-05-11 §2). Brand Guide v1 design tokens + base resets + layout +
// component classes consumed by `src/views/_components/*` components ship
// in follow-on PRs per Decoupled-then-integrate §2.11 Mode 12 ELEVATED.
import './app.css';
// Public re-exports (consumers and the future RN shell import these).
export { App } from './app.js';
export * from './session/index.js';
export * from './api/index.js';
export * as Crypto from './crypto/envelope-crypto-adapter.js';
export * as Projection from './projection/index.js';
export * as Views from './views/index.js';
// Browser-only mount.
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const rootEl = document.getElementById('root');
    if (rootEl !== null) {
        createRoot(rootEl).render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
    }
}
//# sourceMappingURL=index.js.map